module.exports = __webpack_public_path__ + "img/5.86e45238.png";